let state ={
    accountNum:'',
    datas:{
		
	},
	theme:''
	// symbol:'EOS/USDT',
	// renew:'0',
	// pair:'',
	// id:'1',
	// priceScale:100000000,


}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js